/**
 * A file another person attached, in their message (owner 2026-11-01: "each user will have its own files access policies
 * so no other user can download it"): its name and kind only, marked private. The conversation's AI members still read
 * it; no other person can open or download it.
 */
import { useAuiState } from '@assistant-ui/react';
import { FileText, ImageIcon, Lock } from 'lucide-react';

export function OthersMessageAttachment() {
  const attachment = useAuiState((s) => s.attachment);
  const Icon = attachment.type === 'image' ? ImageIcon : FileText;
  return (
    <div className="flex items-center gap-2 rounded-lg border border-border bg-surface px-3 py-2 text-xs">
      <Icon size={16} className="shrink-0 text-muted" aria-hidden />
      <span className="max-w-56 truncate font-medium text-heading">{attachment.name}</span>
      <span className="flex items-center gap-1 text-muted">
        <Lock size={12} aria-hidden />
        Private to its sender
      </span>
    </div>
  );
}
